import StringUtility from 'utils/stringReplacement';

const copy = new StringUtility({
  sessionExpired: {
    link: 'Back to Login',
    message:
      'Your session has timed out due to inactivity. Please login again to resume using the FanAI platform.',
  },
});

export default copy;
